
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.5 10.897h6.3c1.114 0 2.182.418 2.97 1.164a3.87 3.87 0 011.23 2.81v39.75a3.87 3.87 0 01-1.23 2.811 4.323 4.323 0 01-2.97 1.165H15.2a4.323 4.323 0 01-2.97-1.165 3.87 3.87 0 01-1.23-2.81v-39.75a3.87 3.87 0 011.23-2.811 4.323 4.323 0 012.97-1.164h6.3","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M38.3 6.922H25.7c-2.32 0-4.2 1.78-4.2 3.975v1.987c0 2.196 1.88 3.975 4.2 3.975h12.6c2.32 0 4.2-1.78 4.2-3.975v-1.987c0-2.196-1.88-3.975-4.2-3.975z","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.5 38.722l8.4 5.962 10.5-15.9","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    